import { Button, Flex } from "antd";
import { useState } from "react";
import useSaveTransaction from "../../../functions/Transaction/saveTransaction";
import useFetch from "../../../hooks/useFetch";
import useConnectToPrinter from "../../../functions/Printer/connectToPrinter";

export default function Receipt(props) {
  const {
    plates,
    onPaymentSuccessReset,
    transactionInfo,
    setTransactionInfo,
    isDisableCompleteTransactionButton = false,
    setExtraChargesOptions,
    connectDevice,
    setConnectDevice,
  } = props;
  const [fetchWrapper] = useFetch();
  const [isSaved, setIsSaved] = useState(false);
  const [receiptLoading, setReceiptLoading] = useState(false);

  const { connectToPrinter } = useConnectToPrinter(connectDevice, setConnectDevice);

  const onNoReceiptButtonClicked = () => {
    if (!isSaved) {
      //Save transaction into database
      callSaveTransaction(true);
    } else {
      reset();
    }
  };

  // const onPrintReceiptButtonClicked = () => {
  //   if (!isSaved) {
  //     //Save transaction into database
  //     callSaveTransaction(false);
  //     //Trigger receipt printing machine to print receipt
  //     callPrintReceipt();
  //   } else {
  //     //Trigger receipt printing machine to print receipt
  //     callPrintReceipt();
  //   }
  // };

  const { saveTransaction } = useSaveTransaction();

  const callSaveTransaction = (reset_on_save) =>
    saveTransaction(
      plates,
      transactionInfo,
      reset_on_save,
      onTransactionSuccess,
      onTransactionFailed
    );

  // const callPrintReceipt = () => printReceipt(plates, transactionInfo, reset);

  const onTransactionSuccess = (reset_on_save) => {
    setIsSaved(true);
    if (reset_on_save) {
      reset();
    }
  };
  const onTransactionFailed = () => {};

  function reset() {
    setTransactionInfo(null);
    setIsSaved(false);
    onPaymentSuccessReset();
    setExtraChargesOptions((prev) => ({
      ...prev,
      takeaway_fee: false,
    }));
    setReceiptLoading(false);
  }

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <Flex
        gap="middle"
        justify="space-evenly"
        align="center"
        vertical
        style={{ height: "100%", width: "100%" }}
      >
        <div
          style={{
            width: "100%",
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "3vw",
          }}
        >
          {transactionInfo?.invoice_no
            ? "Invoice No: " + transactionInfo?.invoice_no
            : "Generating Invoice No."}{" "}
          <br />
          Do you need to print receipt?
        </div>
        <Flex style={{ width: "100%" }} justify="space-evenly" align="center">
          <Button
            className="no-receipt-btn"
            onClick={onNoReceiptButtonClicked}
            disabled={isDisableCompleteTransactionButton || receiptLoading}
          >
            No, Thanks
          </Button>
          <Button
            className="print-receipt-btn"
            onClick={()=>{
              connectToPrinter(
                setReceiptLoading,
                transactionInfo,
                plates,
                fetchWrapper,
                ()=>{callSaveTransaction(true)}
              )
            }}
            disabled={isDisableCompleteTransactionButton || receiptLoading}
          >
            {receiptLoading ? "Printing receipt ..." : "Yes, Print"}
          </Button>
        </Flex>
      </Flex>
    </div>
  );
}
